import {
  GLOSSARY_SEND_WORD,
  GLOSSARY_GET_SUCCESS,
  GLOSSARY_GET_ERROR,
  GLOSSARY_GET_REQUESTING,
  GLOSSARY_RECEIVE_WORDS,
  GLOSSARY_SORT_BY_OCCURRENCE,
  GLOSSARY_SORT_ALPHABETICALLY,
  GLOSSARY_ON_CHANGE,
  GLOSSARY_DELETE_WORD_REQUESTING,
  GLOSSARY_MODIFY_DEFINITION_REQUESTING,
  GLOSSARY_DELETE_WORD_SUCCESS,
  GLOSSARY_MODIFY_DEFINITION_SUCCESS,
  GLOSSARY_MODIFY_DEFINITION_ERROR,
  GLOSSARY_DELETE_WORD_ERROR,
} from "./constants";

import { LOGOUT } from "../login/constants";
import { emitGlossaryWord } from "../realTime/sagas";
import { IGlossary } from "./types";

const INITIAL_STATE: IGlossary = {
  words: [],
  text: "",
  isDefinitionVisible: false,
  definitionSelected: "",
  definition: "",
  definitionRequesting: false,
  wordSelected: "",
  requesting: false,
  sorted: "alphabetically",
  error: "",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GLOSSARY_DELETE_WORD_REQUESTING:
    case GLOSSARY_MODIFY_DEFINITION_REQUESTING:
      return {
        ...state,
        definitionRequesting: true,
      };

    case GLOSSARY_GET_REQUESTING:
      return {
        ...state,
        requesting: true,
        error: "",
      };

    case GLOSSARY_MODIFY_DEFINITION_SUCCESS:
    case GLOSSARY_DELETE_WORD_SUCCESS:
      return {
        ...state,
        words: action.payload,
        isDefinitionVisible: false,
        definitionRequesting: false,
      };

    case GLOSSARY_GET_SUCCESS:
      return {
        ...state,
        words: action.payload.words,
        error: "",
        requesting: false,
      };

    case GLOSSARY_MODIFY_DEFINITION_ERROR:
    case GLOSSARY_DELETE_WORD_ERROR:
    case GLOSSARY_GET_ERROR:
      return {
        ...state,
        error: action.payload.message,
        requesting: false,
      };

    case GLOSSARY_ON_CHANGE:
      return {
        ...state,
        ...action.payload,
      };

    case GLOSSARY_SORT_BY_OCCURRENCE: {
      return {
        ...state,
        sorted: "occurrence",
      };
    }

    case GLOSSARY_SORT_ALPHABETICALLY: {
      return {
        ...state,
        sorted: "alphabetically",
      };
    }

    case GLOSSARY_SEND_WORD: {
      // socket emit
      emitGlossaryWord(action.payload);
      const word = action.payload.word;
      const wordIndex = state.words.findIndex(el => el.word === word);
      let words = [];
      if (wordIndex > -1) {
        words = state.words.map(el => el);
        words[wordIndex].votes++;
      } else {
        words = [...state.words, { word, votes: 1, definition: "" }];
      }
      return {
        ...state,
        text: "",
        words,
      };
    }

    case GLOSSARY_RECEIVE_WORDS: {
      return {
        ...state,
        words: action.payload,
      };
    }

    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
